import { render, staticRenderFns } from "./KanBanBoardAddCard.vue?vue&type=template&id=71e21f5a&"
import script from "./KanBanBoardAddCard.vue?vue&type=script&lang=js&"
export * from "./KanBanBoardAddCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports